// import dashboard from './dashboard';
// import pages from './pages';
// import utilities from './utilities';
import Dashboard from './dashboard';
import { IconDashboard, IconUsers, IconReceipt } from '@tabler/icons';
// import UtilityBillsAndEMI from './utilityBillsAndEMI';
// import other from './other';
// import Booking from './Booking';
// import AceMoneyEarnMore from './AceMoneyEarnMore';
// import Insurance from './Insurance';
// import AccountAndSavings from './AcountAndSavings';
// import CollectPayment from './CollectPayment';
// import RefferAndEarn from './RefferAndEarn';
// ==============================|| MENU ITEMS ||============================== //

const isSubdistributor = localStorage.getItem('isSubdistributor');
const whitelabelStatus = localStorage.getItem('whitelabelStatus');
const isUrban = localStorage.getItem('IsUrban') === 'true' || localStorage.getItem('IsUrban') === '1';

// Urban Dashboard — simplified menu with only Merchants List and Transactions List
const urbanMenu = {
    id: 'urban-distributor-menu',
    type: 'group',
    children: [
        {
            id: 'urban-dashboard',
            title: 'Dashboard',
            type: 'item',
            icon: IconDashboard,
            url: 'distributor/dashboard',
            breadcrumbs: true
        },
        {
            id: 'urban-merchants-list',
            title: 'Merchants List',
            type: 'item',
            icon: IconUsers,
            url: 'distributor/urban-merchants',
            breadcrumbs: true
        },
        {
            id: 'urban-transactions-list',
            title: 'Transactions List',
            type: 'item',
            icon: IconReceipt,
            url: '/distributor/urban-transactions',
            breadcrumbs: false
        },
        {
            id: 'urban-menu-employee',
            title: 'Employee',
            icon: IconUsers,
            type: 'collapse',
            children: [
                {
                    id: 'urban-menu-employee-create',
                    title: 'Create Employee',
                    type: 'item',
                    url: '/distributor/employee-onboarding',
                    breadcrumbs: false
                },
                {
                    id: 'urban-menu-employee-list',
                    title: 'List Employee',
                    type: 'item',
                    url: '/distributor/listemployee',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

let filteredMenu = Dashboard;

if (isUrban) {
    filteredMenu = urbanMenu;
} else {
    if (isSubdistributor === 'true') {
        const excludedIds = ['tabler-icons92', 'tabler-icons5', 'tabler-icons6'];

        filteredMenu = {
            ...filteredMenu,
            children: filteredMenu.children.filter((child) => !excludedIds.includes(child.id))
        };
    }
    // Condition for whitelabelStatus
    if (whitelabelStatus === 'true') {
        const excludedIds = ['tabler-icons5', 'tabler-icons6'];

        filteredMenu = {
            ...filteredMenu,
            children: filteredMenu.children.filter((child) => !excludedIds.includes(child.id))
        };
    }
}

const distributorMenuItems = {
    items: [filteredMenu]
};

export default distributorMenuItems;
